<template>
  <div class="container">
    <div class="row">
      <div class="col-md-3 align-self-center">
        <h1 class="mb-3" style="margin-top: 30px;">Quem Somos</h1>
      </div>
     <div class="col-md-8 my-3">
        <p v-if="banco === 'tribanco'">
          Há mais de 30 anos o Tribanco entrega as melhores soluções financeiras aos clientes, desenvolvendo e apoiando o crescimento dos varejistas.
          Somos o banco do varejo brasileiro, parceiros do Sistema Martins, o maior atacado distribuidor da América Latina e juntos criamos diversas 
          soluções para impulsionar negócios.
        </p>
        <p v-else>
          Somos uma empresa integrante do Sistema Integrado Martins, um grupo que trabalha ativamente para oferecer soluções de integração entre indústria, 
          varejistas e consumidores, e que acredita em maneiras simples de fortalecer sua marca, de agradar seu público e de fazer seu cliente retornar 
          sempre.
        </p>
        <hr>
      </div>
    </div>
  </div>
  
</template>

<script>

export default {
    name: "Termos",
     components: {
    },
    data: () => ({
        links: [
        ]
    }),
    methods: {
    },
    async created() {
      this.title = this.$route.query.title;
      this.banco = this.$route.query.banco; 
    },
    computed: {
    }
};
</script>
